export default {
  workApprovalWorks: (state) => state.workApprovalWorks,
  workApprovalProductions: (state) => state.workApprovalProductions,
};
